<template>
  <div class="orders-list-status-filter">
    <van-tabs @change="handleChange">
      <van-tab
        v-for="item of tabs"
        :key="item.id"
        :name="item.id"
        :title="item.title"
      />
    </van-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: [
        { id: 0, title: '未使用' },
        { id: 1, title: '已使用' },
        { id: 2, title: '退票处理' },
      ],
    };
  },
  methods: {
    handleChange(id) {
      this.$emit('change', id);
    },
  },
};
</script>
<style lang="less" scoped>
.orders-list-status-filter {
  position: fixed;
  top: 46px;
  width: 100%;
  z-index: 1;
  background: #f9fafb;
}
</style>
